<template>
  <div
    class="row q-gutter-sm"
  >
    <div
      class="col row"
    >
      <showing-badge
        v-for="showingBadge in props.expand ? (props.value.data || props.value) : (props.value.data || props.value).slice(0, props.col.limitValues)"
        :key="showingBadge.id"
        :showing-badge="showingBadge"
        outline
      />
    </div>
    <q-btn
      v-if="props.expand && (props.value.data || props.value).length > props.col.limitValues"
      class="col-auto"
      icon="unfold_less"
      size="sm"
      dense
      @click.stop="props.expand = false"
    />
    <q-btn
      v-else-if="!props.expand && props.col.limitValues < (props.value.data || props.value).length"
      class="col-auto"
      icon="unfold_more"
      size="sm"
      dense
      @click.stop="props.expand = true"
    />
  </div>
</template>

<script>

import ShowingBadge from 'src/modules/admin/showing-badge/components/ShowingBadge'

export default {
  name: 'ShowingBadgesDisplayCell',
  components: {
    ShowingBadge
  },
  props: {
    props: {
      type: Object,
      required: true
    }
  }
}

</script>
